import { CheckboxGroupButtons } from '@/components/_common';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';

import { Col, Form, Radio, Row, Typography } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import { useIntl } from 'react-intl';
import BalanceteCheckboxs from './BalanceteCheckboxs';
import BalanceteMoreOptions from './BalanceteMoreOptions';
import {
  FilterByDate,
  FinancialTrialBalanceForm,
  Situation,
} from '@/core/domain/NetReport/Financial/Financial.types';

interface Props {
  form: FormInstance<FinancialTrialBalanceForm>;
}

const FinancialBalanceteForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;

  const optionsBalancete = [
    {
      value: Situation.open,
      label: intl({
        id: 'financial.billsToPay.form.situation.open',
      }),
    },
    {
      value: Situation.liquidated,
      label: intl({
        id: 'financial.billsToPay.form.situation.liquidated',
      }),
    },
  ];

  return (
    <Form form={form}>
      <ReportSelectMonthFields
        form={form}
        dateFilter={
          <>
            <Title level={5}>
              {intl({ id: 'financial.billsToPay.form.filterByDate' })}
            </Title>

            <Form.Item
              noStyle
              name="dateFilterBy"
              initialValue={FilterByDate.dueDate}
            >
              <Radio.Group optionType="button" buttonStyle="solid" size="large">
                <Radio value={FilterByDate.dueDate}>
                  {intl({
                    id: 'financial.billsToPay.form.filterByDate.maturity',
                  })}
                </Radio>
                <Radio value={FilterByDate.payDate}>
                  {intl({
                    id: 'financial.billsToPay.form.filterByDate.payment',
                  })}
                </Radio>
                <Radio value={FilterByDate.emissionDate}>
                  {intl({
                    id: 'financial.billsToPay.form.filterByDate.issuance',
                  })}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </>
        }
      />

      <Row>
        <Col xs={24}>
          <Title level={5}>
            {intl({
              id: 'financial.billsToPay.form.situation',
            })}
          </Title>
          <Form.Item
            name="situation"
            initialValue={[Situation.open, Situation.liquidated]}
          >
            <CheckboxGroupButtons options={optionsBalancete} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <BalanceteCheckboxs />
        </Col>

        <Col xs={24}>
          <BalanceteMoreOptions />
        </Col>
      </Row>
    </Form>
  );
};

export default FinancialBalanceteForm;
